      <a-table #taskTable
               (selectItem)="onSelectedRow($event)"
               [editable]="false"
               [moveTopButton]="false"
               [pagination]="true"
               [pageSize]="pageSize"
               [footer]="false"
               [dataProvider]="dataProvider" [sortable]="!dataProvider.textSearch"
      >
        <column labelKey="task.search.result.id" property="id" sort="id" [link]="true" (linkClick)="gotoTaskDetail($event)"></column>
        <column labelKey="task.search.result.title" property="title" sort="UPPER(c.title)"></column>
        <column labelKey="task.search.result.type" property="type" sort="textsType.name" dictionary="TaskType"></column>
        <column labelKey="task.search.result.businessObject"(linkClick)="goToBusinessObject($event)" [link]="true">
          <ng-template let-item="item">
            {{item.businessObject?.relatedTo?.name}} / {{item.businessObject?.description}}
            <ng-container *ngIf="item.taskBusinessObjectProduct">
              / {{item.taskBusinessObjectProduct.name}}
            </ng-container>
          </ng-template>
        </column>
        <column labelKey="task.search.result.closureDate" sort="closureDate" property="closureDate" type="date"></column>
        <column labelKey="task.search.result.automatic" property="autoGenerated" type="checkbox" sort="autoGenerated"></column>
        <column labelKey="task.search.result.important" property="important" type="checkbox" sort="important"></column>
        <column labelKey="task.search.result.status" property="status" dictionary="TaskStatus" sort="textsStatus.name"></column>
        <column labelKey="task.search.result.user" sort="user.familyName">
          <ng-template let-item="item" let-edition="edition">{{item.user | username}}</ng-template>
        </column>
        <column labelKey="task.search.result.group" sort="userGroup.name" property="userGroup.name">
        </column>
        <column labelKey="task.search.result.dueDate" property="dueDate" type="date" sort="dueDate" initialSort="UP"></column>
        <column labelKey="task.search.result.creationDate" property="creationDate" type="date" sort="creationDate"></column>
        <column labelKey="task.search.result.companyName">
          <ng-template let-item="item" let-edition="false">{{item?.businessObject?.reference?.shortName && showShortNameIfExists ? item?.businessObject?.reference?.shortName : item?.businessObject?.reference?.registrationName}}</ng-template>
        </column>
        <column labelKey="task.search.result.businessUnit" property="businessUnit.name"></column>
      </a-table>
